import CityPageTemplate from "../city-template/CityPageTemplate";
import { rosevilleConfig } from "./data";

export default function RosevillePage() {
  return <CityPageTemplate config={rosevilleConfig} />;
}